import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=c905e3be&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=js"
export * from "./cabinet.vue?vue&type=script&lang=js"
import style0 from "./cabinet.vue?vue&type=style&index=0&id=c905e3be&prod&lang=scss&scoped=true"
import style1 from "./cabinet.vue?vue&type=style&index=1&id=c905e3be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c905e3be",
  null
  
)

export default component.exports